import { useAppSelector } from 'app/hooks';
import axios from 'axios';
import Button from 'blocks/Button';
import FlightCard from 'components/Flight/FlightList/FlightCard';
import Loading from 'components/Loading';
import { getDate } from 'helper/date';
import Paths from 'helper/paths';
import { OriginDestinationInformation, OriginDestinationOptions } from 'models/flight/flitghtResponse.interface';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { getUserService } from 'services/userInfo.service';
import {
  complementaryFormDataState,
  flightFormDataState,
  flightList,
  formDataToQuery,
  setFlightList,
} from 'store/flight/flightSlice';
import { setUser, setUserInfoError, setUserInfoLoading, userInfoState } from 'store/userInfo/userInfoSlice';
import urls from 'utils/urls';
import * as S from './flightList.styles';
const FlightList = ({ discountTicketId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { departureText, destinationText } = useAppSelector(complementaryFormDataState);
  const flightFormData = useAppSelector(flightFormDataState);
  const formDataQueryState = useAppSelector(formDataToQuery);
  const flightListState = useAppSelector(flightList);
  const usersInfo = useAppSelector(userInfoState);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const getFlights = async () => {
    setLoading(true);
    await dispatch(setFlightList([]));
    if (!formDataQueryState.includes('dateTime')) return null;
    const res = await axios.get(urls.discountAirAvailRoute + `?searchType=STANDARD&${formDataQueryState}`);

    if (formDataQueryState.includes('returnDateTime') && res.data.response.originDestinationInformation.length !== 2)
      return null;
    if (res && res.status === 200) {
      const flightList = [] as OriginDestinationOptions[];
      const originDestinationInformation = res.data.response
        .originDestinationInformation as OriginDestinationInformation[];
      originDestinationInformation.sort((a, b) => {
        return a.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime >
          b.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime
          ? 1
          : -1;
      });
      if (res.data.response.originDestinationInformation.length === 2)
        for (const i in originDestinationInformation[0].originDestinationOptions.originDestinationOption) {
          const wentFlight = originDestinationInformation[0].originDestinationOptions.originDestinationOption[i];
          for (const j in originDestinationInformation[1].originDestinationOptions.originDestinationOption) {
            const returnFlight = originDestinationInformation[1].originDestinationOptions.originDestinationOption[j];
            if (
              returnFlight.flightSegment[0].departureDateTime >
              wentFlight.flightSegment[wentFlight.flightSegment.length - 1].arrivalDateTime
            )
              flightList.push({ originDestinationOption: [wentFlight, returnFlight] });
          }
        }
      else {
        for (const i in originDestinationInformation[0].originDestinationOptions.originDestinationOption) {
          const wentFlight = originDestinationInformation[0].originDestinationOptions.originDestinationOption[i];
          flightList.push({ originDestinationOption: [wentFlight] });
        }
      }

      await dispatch(setFlightList(flightList));
      return;
    }
  };

  const backToSearch = () => {
    navigate(Paths.Services.discount().route + '?' + formDataQueryState);
  };

  useEffect(() => {
    if (!loading)
      getFlights().finally(() => {
        getUserData();
        setLoading(false);
      });
  }, []);

  const getUserData = () => {
    dispatch(setUserInfoLoading('userInfo'));
    getUserService()
      .then((res) => {
        dispatch(setUser(res.data));
      })
      .catch((err) => {
        dispatch(setUserInfoError({ type: 'userInfo', err }));
      });
  };

  return (
    <>
      <S.PageTitle>
        {t('pages.services.flight.pages.book.sections.list.title.prefix')}
        <b>
          {t('pages.services.flight.pages.book.sections.list.title.data', {
            from: departureText,
            to: destinationText,
          })}
        </b>
        {!flightFormData.returnDateTime
          ? t('pages.services.flight.pages.book.sections.list.title.oneWayDate', {
              date: getDate(flightFormData.dateTime),
            })
          : t('pages.services.flight.pages.book.sections.list.title.twoWayDate', {
              wentDate: getDate(flightFormData.dateTime),
              returnDate: getDate(flightFormData.returnDateTime),
            })}
      </S.PageTitle>
      {usersInfo.loading || loading ? (
        <Loading fullScreen={false} />
      ) : (
        <S.Card>
          {flightListState && flightListState.length ? (
            <>
              <S.FlightCardList>
                {flightListState.map((e, i) => {
                  return (
                    <S.FlightCard key={i}>
                      <FlightCard flight={e} discountTicketId={discountTicketId} />
                    </S.FlightCard>
                  );
                })}
              </S.FlightCardList>
              <div>
                <S.Btn as={Button} onClick={backToSearch} width={134}>
                  {t('pages.services.flight.pages.book.sections.list.emptyListBox.editCTA')}
                </S.Btn>
              </div>
            </>
          ) : (
            <>
              <S.NotFoundText>{t('pages.services.flight.pages.book.sections.list.emptyListBox.text')}</S.NotFoundText>
              <S.Btn as={Button} onClick={backToSearch} width={134}>
                {t('pages.services.flight.pages.book.sections.list.emptyListBox.editCTA')}
              </S.Btn>
            </>
          )}
        </S.Card>
      )}
    </>
  );
};

export default FlightList;
